export default __webpack_public_path__ + "static/media/mainlogo.3819a5ea.svg";